module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp16-a4bf62b7df89a94d5cc11695b5c82f35.jpg";